import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "AzeAuksion.az";
const DEFAULT_DESC = "Azərbaycanın online avtomobil auksion platforması. Avtomobilinizi auksiona çıxarın, ən yüksək təklifi alın. Minlərlə real alıcı, şəffaf təkliflər.";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?w=1200&q=80";

export default function Seo({ title, description, image, path = "", schema, noindex = false }) {
  const base = typeof window !== "undefined" ? window.location.origin : "https://azeauksion.com";
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Avtomobil auksionu`;
  const desc = description || DEFAULT_DESC;
  const url = `${base}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={schema?.["@type"] === "Vehicle" ? "product" : "website"} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="az_AZ" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Structured data */}
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
}
